
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/site/vs/make",
      function () {
        return require("private-next-pages/site/vs/make.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/site/vs/make"])
      });
    }
  